import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EmployeeAssesment, Metric, Approvalform, MetricDto } from 'src/app/shared/models/appraisal';
import { ApparaisalService } from 'src/app/shared/services/apparaisal.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { Context } from 'src/app/shared/models/context';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Message } from 'src/app/shared/models/domain';
@Component({
  selector: 'app-approval-matrix',
  templateUrl: './approval-matrix.component.html',
  styleUrls: ['./approval-matrix.component.scss']
})
export class ApprovalMatrixComponent implements OnInit {
  @Output() matrics = new EventEmitter<{ id: number; name: string; label: string; metricComments: string }>();
  @Input() employeeAssesment!: EmployeeAssesment;
  @Input() isActive : boolean;
  @Output() emitWizardIndex = new EventEmitter<number>();
  public submitted: boolean = false;
  public metricForm: FormGroup;
  private modified: boolean = false;
  public metrics: Metric[] = [];
  public metricId: number | null = null;
  public comments: string = "";
  public metricComments: string = "";
  public names: string = "";
  public approval!: Approvalform;
  public context!: Context;
  public isAssesmentCompleted: boolean = false;
  public metric:Metric;
  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private appraisalService: ApparaisalService,
    private commonService: CommonService,
  ) { }

  ngOnInit(): void {
    this.isAssesmentCompleted = this.commonService.isAssesmentCompleted(this.employeeAssesment.status);
    this.employeeAssesment = { ...this.employeeAssesment };
    this.setMetrics();
  }

  private setMetrics(): void {
    this.appraisalService.getMatrics().subscribe({
      next: (metrics: Metric[]) => {
        this.metrics = metrics;
        this.getEmployeeAssessment();
        // this.getMertic(this.metricId)
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error('Failed to load metrics', 'Error');
      }
    });
  }
  public onMetricChange(event: any): void {
    const selectedMetric = this.metrics.find(metric => metric.id === this.metricId);
    if (selectedMetric) {
      this.names = selectedMetric.name || '';
      this.comments = selectedMetric.label || '';
      this.metricComments = this.employeeAssesment.metricRemarks || '';
    } else {
      this.resetMetricValues();
    }
  }
  private resetMetricValues(): void {
    this.metricId = null;
    this.names = '';
    this.comments = '';
    this.metricComments = '';
  }

  public getEmployeeAssessment(): void {
    if (this.employeeAssesment?.appraisalId && this.employeeAssesment?.appraiseeId) {
      this.appraisalService.getAssessment(this.employeeAssesment.appraisalId, this.employeeAssesment.appraiseeId).subscribe({
        next: (employeeAssessment: EmployeeAssesment) => {
          this.employeeAssesment = employeeAssessment;
          this.metricId=employeeAssessment.metricId
          if (employeeAssessment.metricId) {
            this.getMertic(employeeAssessment.metricId)
            this.metricId = employeeAssessment.metricId;
            this.names = employeeAssessment.metricName || '';
            // this.comments = employeeAssessment.l || '';
            this.metricComments = employeeAssessment.metricRemarks || '';
          } 
          else {
            this.resetMetricValues();
          }
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.error('Failed to load employee assessment', 'Error');
        }
      });
    }
  }

  public upsertMetrics(): void {
    if (this.isActive){
      return;
    }
    // if (!this.employeeAssesment.metricDto) {
    //   this.employeeAssesment.metricDto = {} as Metric;
    // }
    // this.employeeAssesment.hikeDto = null;
    this.employeeAssesment.metricId = this.metricId;
    
    this.employeeAssesment.metricName = this.names;
    this.employeeAssesment.metricRemarks = this.comments;
    this.employeeAssesment.metricRemarks = this.metricComments;
    this.employeeAssesment.status = "LONE_METRICS"
    this.appraisalService.updateApprovalForm(this.employeeAssesment.id, this.employeeAssesment).subscribe({
      next: (response: Message) => {
        if (!response.failed) {
        this.commonService.setToastr(200, "Metrics Saved Successfully");
        this.emitWizardIndex.emit(3);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error(error?.error?.message || 'An error occurred while saving metrics');
      }
    });
  }

  public submitMetrics(): void {
    if (this.metricId) {
      this.matrics.emit({ id: this.metricId, name: this.names, label: this.comments, metricComments: this.metricComments });
    } else {
      this.toastr.warning('Please select a metrics before submitting', 'Warning');
    }
  }

  public getMertic(id:number) {
    if (this.metricId) {
      this.appraisalService.getMertic(id).subscribe({
        next: (metric: Metric) => {
          this.metric = metric;
          this.comments=this.metric.label;
        },
        error: (error: HttpErrorResponse) => {
        }
      });
    }
  }
}
